import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Storage } from 'aws-amplify';
import { APIService, CreateNavigationNodeInput } from '../../API.service';
import { v4 as uuid } from 'uuid'
import { environment } from 'src/environments/environment';
import { AuthenticatorService } from '@aws-amplify/ui-angular';

@Component({
  selector: 'app-node-form',
  templateUrl: './node-form.component.html',
  styleUrls: ['./node-form.component.scss']
})
export class NodeFormComponent implements OnInit {

  institutionId: string;
  parentNodeId: string;
  nodeId: string = null;
  levelName: string;
  loading: boolean;
  nodeForm: FormGroup;
  imageFile: File;

  constructor(
    private activatedRoute: ActivatedRoute, 
    private api: APIService, 
    private router: Router, 
    private formBuilder: FormBuilder,
    private authenticator: AuthenticatorService) { }

  async ngOnInit() {

    this.loading = true;

    var routeSub = this.activatedRoute.params.subscribe(async params => {

      var node : {
        label: string,
        description: string,
        image: string,
        visible: boolean
      } = {
        label: '',
        description: '',
        image: '',
        visible: true
      }

      this.nodeId = params["nodeId"] ?? null;

      if (this.nodeId) {
        
        var n = await this.api.GetNavigationNode(this.nodeId);

        this.institutionId = n.institution.id;
        this.parentNodeId = n.parentConnection ? n.parentConnection.parentId : null;

        this.levelName = this.parentNodeId ? n.institution.navigationNodeLevelNames[1] : n.institution.navigationNodeLevelNames[0];

        node.label = n.label;
        node.description = n.description;
        node.visible = n.visible ?? true;

        if (n.image){
          node.image = environment.cloudfrontUrl + n.image;
        }

      } else {

        this.institutionId = params["institutionId"];
        this.parentNodeId = params["parentNodeId"] ?? null;

        var institution = await this.api.GetInstitution(this.institutionId)
      
        if (this.parentNodeId) {
          this.levelName = institution.navigationNodeLevelNames[1]
        } else {
          this.levelName = institution.navigationNodeLevelNames[0]
        }

      }
      
      this.nodeForm = this.formBuilder.group({
        label: this.formBuilder.control(node.label, [Validators.required]),
        description: this.formBuilder.control(node.description),
        image: this.formBuilder.control(node.image),
        visible: this.formBuilder.control(node.visible, [Validators.required])
      })

      this.loading = false;

      routeSub.unsubscribe()

    })

  }

  onImageChange(event) {
    this.imageFile = event.target.files[0];
    var imageFormControl = this.nodeForm.controls.image as FormControl
    var fileReader = new FileReader();
    fileReader.onload = () => {
      imageFormControl.setValue(fileReader.result)
    }
    fileReader.readAsDataURL(this.imageFile)
  }

  async submit() {

    if (this.nodeForm.invalid) {
      return;
    }

    this.loading = true;

    try {

      var node : CreateNavigationNodeInput = {
        navigationNodeInstitutionId: this.institutionId,
        label: this.nodeForm.value.label,
        description: this.nodeForm.value.description,
        active: true,
        image: null,
        visible: this.nodeForm.value.visible,
        ownerID: this.authenticator.user.attributes.sub
      }

      if (this.imageFile) {
        var key = uuid();
        await Storage.put(key, this.imageFile, { contentType: this.imageFile.type, })
        node.image = key;
      } else {
        node.image = ''
      }

      if (this.nodeId) {

        await this.api.UpdateNavigationNode({
          id: this.nodeId,
          ...node
        })

      } else {

        if (this.parentNodeId) {

          var order = 0;

          var newNode = await this.api.CreateNavigationNode(node)
        
          var siblingConnections = await this.api.ListNavigationNodeConnections({parentId: { eq: this.parentNodeId }})

          if (siblingConnections.items != null){
            siblingConnections.items.forEach(nnc => {
              if (nnc.order > order){
                order = nnc.order;
              }
            })
          }
        
          await this.api.CreateNavigationNodeConnection({
            id: newNode.id,
            navigationNodeConnectionInstitutionId: this.institutionId,
            parentId: this.parentNodeId,
            order: order
          })

        } else {

          var order = 0;

          var siblingNodes = await this.api.GetInstitutionWithNodes(this.institutionId, this.authenticator.user.attributes.sub)
          
          if (siblingNodes.navigationNodes != null && siblingNodes.navigationNodes.items != null) {
            siblingNodes.navigationNodes.items.forEach(nn => {
              if (nn.parentConnection == null && nn.active && nn.order > order){
                order = nn.order + 1;              
              }
            })
          }

          await this.api.CreateNavigationNode({
            order: order,
            ...node
          })

        }

      }

      this.cancel()

    } catch (error) {

      this.loading = false;

    }

  }

  cancel() {

    var commands = ["home"]

    if (this.parentNodeId) {
      commands.push(this.parentNodeId)
    }

    this.router.navigate(commands)

  }

}
